<app-modal-header
  [automaticClose]="false"
  (closeEvent)="onClose()"
  (click)="onPrevent($event)"
  class="border-b-2 border-theme-500"
>
  <div class="flex w-full items-center gap-2">
    <div class="flex">
      <svg-icon class="w-10 text-theme-500" src="assets/icons/icon-text-magic.svg"></svg-icon>
    </div>
    <hr app-modal-divider />
    <div>
      <div class="mr-5 flex w-full items-center justify-between pt-2">
        <div class="flex w-full gap-2">
          <span class="text-lg text-black" translate> IA </span>
        </div>
      </div>
    </div>
  </div>
</app-modal-header>

<div app-modal-content (click)="onPrevent($event)" class="h-[70vh] w-full !p-0 sm:w-[80vw]">
  <app-sidenav-group>
    <ng-template app-sidenav-outer>
      <div class="p-4">
        <div class="flex items-center justify-between">
          <span class="text-md font-semibold" translate> ia.conteudo-original </span>
          <div *ngIf="{ value: loading$ | async } as loading" class="flex gap-2">
            <ng-container *ngIf="isImage; else textOptionsTemplate">
              <button
                app-flat-button
                (click)="onMagicText(magicTextTypeEnum.Transcript)"
                [disabled]="!!loading.value"
                class="gap-2 border-theme bg-white"
              >
                <svg-icon class="flex h-6 w-6 text-theme" src="assets/icons/icon-text-rewrite.svg"></svg-icon>
                <span class="whitespace-nowrap" translate> ia.tipos.transcrever </span>
              </button>
              <button
                app-flat-button
                (click)="onMagicText(magicTextTypeEnum.TranscriptLateX)"
                [disabled]="!!loading.value"
                class="gap-2 border-theme bg-white"
              >
                <svg-icon class="flex h-6 w-6 text-theme" src="assets/icons/icon-text-rewrite.svg"></svg-icon>
                <span class="whitespace-nowrap" translate> ia.tipos.transcrever-latex </span>
              </button>
            </ng-container>
            <ng-template #textOptionsTemplate>
              <button
                app-flat-button
                (click)="onMagicText(magicTextTypeEnum.Rewrite)"
                [disabled]="!!loading.value"
                class="gap-2 border-theme bg-white"
              >
                <svg-icon class="flex h-6 w-6 text-theme" src="assets/icons/icon-text-rewrite.svg"></svg-icon>
                <span class="whitespace-nowrap" translate> ia.tipos.reescrever </span>
              </button>
              <button
                app-flat-button
                (click)="onMagicText(magicTextTypeEnum.Shorten)"
                [disabled]="!!loading.value"
                class="gap-2 border-theme bg-white"
              >
                <svg-icon class="flex h-6 w-6 text-theme" src="assets/icons/icon-text-shorten.svg"></svg-icon>
                <span class="whitespace-nowrap" translate> ia.tipos.encurtar </span>
              </button>

              <button
                app-flat-button
                (click)="onMagicText(magicTextTypeEnum.Revise)"
                [disabled]="!!loading.value"
                class="gap-2 border-theme bg-white"
              >
                <svg-icon class="flex h-6 w-6 text-theme" src="assets/icons/icon-text-abc.svg"></svg-icon>
                <span class="whitespace-nowrap" translate> ia.tipos.corrigir-ortografia </span>
              </button>
            </ng-template>
          </div>
        </div>
        <div
          class="mt-5 overflow-y-auto rounded-xl border-x border-b border-base-gray-100 bg-base-gray-light-200 p-4 shadow-inner-bg"
        >
          <img *ngIf="isImage; else textTemplate" class="w-full" [src]="data.url" />
          <ng-template #textTemplate>
            <span class="ck-content" [innerHTML]="data.text | safe : 'html'"></span>
          </ng-template>
        </div>
      </div>
    </ng-template>
    <ng-template app-sidenav-end panelWidth="500px" [opened]="true">
      <div *ngIf="{ value: activeResultData$ | async } as activeResultData" class="flex flex-col p-4">
        <div class="flex items-center">
          <span class="text-md font-semibold" translate>geral.resultado</span>
          <ng-container *ngIf="!!activeResultData.value">
            <button
              app-icon-button
              app-tooltip
              (click)="onPrior()"
              [tooltip]="'geral.anterior' | translate"
              type="button"
              class="!rounded-full bg-white"
            >
              <svg-icon class="flex h-5" src="assets/icons/icon-arrow-left-fine.svg"></svg-icon>
            </button>
            <span> {{ activeResultData.value.order }}/{{ total }} </span>
            <button
              app-icon-button
              app-tooltip
              (click)="onNext()"
              [tooltip]="'geral.proximo' | translate"
              type="button"
              class="!rounded-full bg-white"
            >
              <svg-icon class="flex h-5" src="assets/icons/icon-arrow-right-fine.svg"></svg-icon>
            </button>
            <span class="text-sm">{{ activeResultData.value.type_legend }}</span>
          </ng-container>
        </div>
        <div class="mt-5">
          <ng-container *ngIf="!!activeResultData.value; else emptyTemplate">
            <app-text-editor [formControl]="textEditorCtrl" [toolbar]="editorConfigToolbar"></app-text-editor>
          </ng-container>
          <ng-template #emptyTemplate>
            <div class="grid h-auto gap-4">
              <app-card>
                <div app-card-content class="h-[200px]">
                  <app-skeleton *ngIf="loading$ | async; else jumbotron"></app-skeleton>
                  <ng-template #jumbotron>
                    <app-jumbotron>
                      <span translate> ia.escolha-a-acao-desejada </span>
                    </app-jumbotron>
                  </ng-template>
                </div>
              </app-card>
            </div>
          </ng-template>
          <!-- <span class="absolute text-sm text-right right-3" translate> ia.ia-pode-cometer-erros </span> -->
          <div
            class="mt-5 flex flex-col rounded-lg border border-base-status-info-300 bg-base-status-info-50 px-5 py-2"
          >
            <div class="flex gap-2">
              <svg-icon
                class="flex w-[14px] text-base-status-info-500"
                src="assets/icons/icon-notify-fine.svg"
                alt="icon"
              ></svg-icon>
              <span class="font-semibold" translate> geral.obs </span>
            </div>
            <ng-container *ngIf="isImage; else textObsTemplate">
              <p class="text-sm text-zinc-900" translate>ia.ia-pode-cometer-erros-imagem</p>
              <div class="flex gap-2">
                <svg-icon
                  class="flex w-[14px] text-base-status-info-500"
                  src="assets/icons/icon-notify-fine.svg"
                  alt="icon"
                ></svg-icon>
                <span class="font-semibold" translate> Gerando LaTeX </span>
              </div>
              <p class="text-sem text-zinc-900" translate>ia.formulas-latex</p>
            </ng-container>
            <ng-template #textObsTemplate>
              <p class="text-sm text-zinc-900" translate>ia.ia-pode-cometer-erros-texto</p>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-template>
  </app-sidenav-group>
</div>

<div app-modal-footer (click)="onPrevent($event)" class="flex justify-between">
  <button
    app-button
    type="button"
    class="border !border-solid border-base-status-danger bg-white px-4 font-semibold uppercase text-base-status-danger"
    (click)="onClose()"
    translate
  >
    geral.cancelar
  </button>

  <button
    app-button
    type="button"
    (click)="onConfirm()"
    [disabled]="loading$ | async"
    class="bg-theme-700 px-4 font-semibold uppercase text-theme-contrast"
    translate
  >
    geral.confirmar
  </button>
</div>
